class Alert {

    constructor($injector) {
        this.injector = $injector;
        this.translate = this.injector.get('$translate');
        this.sweetAlert = this.injector.get('SweetAlert');
        this.promise = this.injector.get('$q');
        this.show = this.injector.get('growl');
    }

    success(title, message) {
        return this.show.success(message, {title});
    }

    info(title, message) {
        return this.show.info(message, {title});
    }

    warning(title, message) {
        return this.show.warning(message, {title});
    }

    error(title, message, useContentAsHtml) {
        return this.sweetAlert.swal({
            title: title,
            text: message,
            html: !!useContentAsHtml,
            type: 'error'
        });
    }

    confirm(options) {
        return new Promise((resolve, reject) => {
            this.sweetAlert.swal({
                title: options.title,
                text: options.message,
                type: options.type,
                showCancelButton: true,
                confirmButtonColor: options.confirmBtnColor || '#9C63FF',
                confirmButtonText: options.confirmBtn,
                showLoaderOnConfirm: options.wait,
                closeOnConfirm: !options.wait
            }, function (isConfirm) {
                isConfirm ? resolve() : reject();
            });
        });
    }

    animatedAlert(title, content, animation, options) {
        const defaultOptions = {
            animationConfig: {
                background: 'transparent',
                speed: 1,
                autoplay: true,
                loop: false
            },
            showCancelButton: true,
            showConfirmButton: true,
            allowEscapeKey: true,
            allowOutsideClick: true,
            confirmButtonColor: "#9C63FF",
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            closeOnConfirm: true,
            closeOnCancel: true,
            customClass: 'lottie-alert',
            title: "&nbsp;",
            wait: false,
        };
        options = _.isObject(options) ? _.defaultsDeep(options, defaultOptions) : defaultOptions;

        return new Promise((resolve, reject) => {
            this.sweetAlert.swal({
                    showCancelButton: options.showCancelButton,
                    confirmButtonColor: options.confirmButtonColor,
                    confirmButtonText: options.confirmButtonText,
                    cancelButtonText: options.cancelButtonText,
                    closeOnConfirm: options.closeOnConfirm,
                    closeOnCancel: options.closeOnCancel,
                    customClass: options.customClass,
                    showConfirmButton: options.showConfirmButton,
                    allowEscapeKey: options.allowEscapeKey,
                    allowOutsideClick: options.allowOutsideClick,
                    title: options.title,
                    text: `<lottie-player
                                src="/deposits/lottie-animations/${animation}.json" 
                                background="${options.animationConfig.background}"
                                speed="${options.animationConfig.speed}" 
                                ${options.animationConfig.autoplay ? 'autoplay' : ''} ${options.animationConfig.loop ? 'loop' : ''}></lottie-player>
                                <img class="lottie-swal-img" src="/deposits/lottie-animations/${animation}.png" />
                                <h1>${title}</h1>
                                <p>${content}</p>`,
                    html: true,
                    wait: options.wait,
                },
                (isConfirm) => {
                    isConfirm ? resolve() : reject();
                });
        });
    }

    showFailedError(messageOverride, titleOverride) {
        return this.animatedAlert(
            titleOverride || this.translate.instant('general.alerts.oops.title'),
            messageOverride || this.translate.instant('general.alerts.oops.content'),
            'failed',
            {
                showCancelButton: false,
                confirmButtonColor: '#e01249',
                confirmButtonText: this.translate.instant('general.verbs.ok')
            }
        )
    }

    hide() {
        this.sweetAlert.close();
    }

    handle(response) {
        const ignore = [
            'backdrop click',
            'escape key press',
            'cancel',
        ];

        if (response && _.get(response, 'data.status') === 422) {
            let errorString = '';
            errorString += '<ul>';
            _.each(_.get(response, 'data.validation_errors'), (errors, fieldKey) => {
                _.each(errors, (curError) => {
                    errorString += '<li>' + curError + '</li>';
                });
            });
            errorString += '</ul>';

            return this.showFailedError(
                errorString || this.translate.instant('general.alerts.data_invalid.content'),
                this.translate.instant('general.alerts.data_invalid.title')
            );
        } else if (response && _.get(response, 'data.status_code') === 422) {
            let errorString = '';
            errorString += '<ul>';
            _.each(_.get(response, 'data.errors'), (errors, fieldKey) => {
                _.each(errors, (curError) => {
                    errorString += '<li>' + curError + '</li>';
                });
            });
            errorString += '</ul>';

            return this.showFailedError(
                errorString || this.translate.instant('general.alerts.data_invalid.content'),
                this.translate.instant('general.alerts.data_invalid.title')
            );
        } else if (response && ignore.indexOf(response) === -1) {
            if (response.data) {
                return this.showFailedError(response.data.message);
            }

            if (response.message) {
                return this.showFailedError(response.message);
            }

            this.showFailedError();
        }
    }

}

angular
    .module('festzelt-os.components')
    .service(
        'Alert',
        [
            '$injector',
            ($injector) => new Alert($injector)
        ]
    );



// WEBPACK FOOTER //
// ./src/app/components/services/alerts/alert-service.js